// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Vv-z","tooltipWrapper":"Wv-z","icon":"Xv-z","tooltip":"Yv-z","content":"Zv-z"};